// extracted by mini-css-extract-plugin
export default {"copy":"FooterCopy_copy__h-LpM"};